import React from "react";

import { ErrorScreen } from "../../../components/errorBoundary/errorScreen";
import Loading from "../../../components/loading/loading";

export interface SuspenseComponentProps<T> {
    data?: T;
}

type SuspenseComponentType<T> = React.ComponentType<SuspenseComponentProps<T>>;

interface SuspenseContainerProps<T> {
    data?: T;
    isLoading: boolean;
    error?: Error;
    component: SuspenseComponentType<T>;
}

export class SuspenseContainer<T> extends React.Component<SuspenseContainerProps<T>> {
    render() {
        const { data, isLoading, error, component: Component } = this.props;

        if (isLoading) {
            return <Loading />;
        }

        if (error) {
            return <ErrorScreen error={error} />;
        }

        return <Component data={data} />;
    }
}